import { useParams, Link, Navigate } from 'react-router-dom';
import { getArticleBySlug, articles } from '../data/articlesData';
import imgBuildingSea from '../assets/images/building-sea-view.jpg';
import imgHighrise from '../assets/images/highrise-sea.jpg';
import imgInteriorLiving from '../assets/images/interior-living.jpg';
import imgInteriorBedroom from '../assets/images/interior-bedroom.jpg';
import imgInteriorKitchen from '../assets/images/interior-kitchen.jpg';
import imgSeaBalcony from '../assets/images/sea-view-balcony.jpg';
import imgFacade from '../assets/images/building-facade.jpg';
import imgJerusalem from '../assets/images/jerusalem.jpg';
import imgConsultation from '../assets/images/consultation.jpg';
import imgContract from '../assets/images/contract.jpg';
import imgCityAerial from '../assets/images/city-aerial.jpg';
import imgTelAvivBeach from '../assets/images/tel-aviv-beach.jpg';
import imgTelAvivModern from '../assets/images/tel-aviv-modern.jpg';
import imgHaifaReal from '../assets/images/haifa-real.jpg';
import imgNetanyaSea from '../assets/images/netanya-sea.jpg';
import imgNegev from '../assets/images/negev-desert.jpg';
import imgJerusalemReal from '../assets/images/jerusalem-real.jpg';

const IMG_MAP = {
  'building-sea-view': imgBuildingSea,
  'highrise-sea': imgHighrise,
  'interior-living': imgInteriorLiving,
  'interior-bedroom': imgInteriorBedroom,
  'interior-kitchen': imgInteriorKitchen,
  'sea-view-balcony': imgSeaBalcony,
  'building-facade': imgFacade,
  'jerusalem': imgJerusalem,
  'jerusalem-real': imgJerusalemReal,
  'consultation': imgConsultation,
  'contract': imgContract,
  'city-aerial': imgCityAerial,
  'tel-aviv-beach': imgTelAvivBeach,
  'tel-aviv-modern': imgTelAvivModern,
  'haifa-real': imgHaifaReal,
  'netanya-sea': imgNetanyaSea,
  'negev-desert': imgNegev,
};

export default function BlogPost() {
  const { slug } = useParams();
  const article = getArticleBySlug(slug);
  if (!article) return <Navigate to="/blog" replace />;

  const others = articles.filter(a => a.slug !== slug).slice(0, 3);
  const coverSrc = article.coverImage ? IMG_MAP[article.coverImage] : null;

  const renderBlock = (block, i) => {
    if (block.type === 'h2') return (
      <h2 key={i} style={{ marginTop: '2.5rem', marginBottom: '0.75rem' }}>{block.text}</h2>
    );
    if (block.type === 'p') return (
      <p key={i} style={{ lineHeight: 1.9, color: 'var(--color-text)', fontSize: '1rem' }}>{block.text}</p>
    );
    if (block.type === 'insight') return (
      <div key={i} className="insight-box">{block.text}</div>
    );
    if (block.type === 'photo') return (
      <figure key={i} style={{ margin: '2rem 0', borderRadius: 'var(--radius-lg)', overflow: 'hidden' }}>
        <img
          src={IMG_MAP[block.src]}
          alt={block.caption || ''}
          style={{ width: '100%', height: 320, objectFit: 'cover', display: 'block' }}
        />
        {block.caption && (
          <figcaption style={{ padding: '0.625rem 1rem', background: 'var(--color-bg)', fontSize: '0.78rem', color: 'var(--color-text-muted)', fontStyle: 'italic', textAlign: 'center' }}>
            {block.caption}
          </figcaption>
        )}
      </figure>
    );
    if (block.type === 'qa') return (
      <div key={i} style={{ margin: '2rem 0', borderRadius: 'var(--radius-lg)', overflow: 'hidden', border: '1px solid var(--color-border)' }}>
        {/* Question */}
        <div style={{ background: 'var(--color-bg)', padding: '1.25rem 1.5rem', display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
          <div style={{
            width: 40, height: 40, borderRadius: '50%', background: 'var(--color-primary)',
            color: '#fafaf8', display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1rem', flexShrink: 0
          }}>
            {block.name.charAt(0)}
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: '0.88rem', color: 'var(--color-primary)', marginBottom: '0.25rem' }}>
              {block.name} <span style={{ fontWeight: 400, color: 'var(--color-text-muted)' }}>· {block.origin}</span>
            </div>
            <p style={{ margin: 0, fontSize: '0.95rem', lineHeight: 1.7, color: 'var(--color-text)', fontStyle: 'italic' }}>
              "{block.question}"
            </p>
          </div>
        </div>
        {/* Réponse */}
        <div style={{ background: 'var(--color-bg-white)', padding: '1.25rem 1.5rem', borderTop: '2px solid var(--color-accent)', display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
          <div style={{
            width: 40, height: 40, borderRadius: '50%', background: 'var(--color-accent)',
            color: '#0d1f3c', display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '0.75rem', flexShrink: 0,
            letterSpacing: '0.04em'
          }}>
            DI
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: '0.88rem', color: 'var(--color-accent)', marginBottom: '0.25rem' }}>
              Deal Israel
            </div>
            <p style={{ margin: 0, fontSize: '0.95rem', lineHeight: 1.75, color: 'var(--color-text)' }}>
              {block.answer}
            </p>
          </div>
        </div>
      </div>
    );
    return null;
  };

  return (
    <div className="page-content">
      <div className="container" style={{ maxWidth: 780 }}>

        {/* Breadcrumb */}
        <div style={{ marginBottom: '1.5rem', fontSize: '0.82rem', color: 'var(--color-text-muted)', display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <Link to="/blog" style={{ color: 'var(--color-primary)', fontWeight: 600 }}>Guide & Articles</Link>
          <span style={{ color: 'var(--color-border)' }}>/</span>
          <span>{article.category}</span>
        </div>

        {/* Meta */}
        <div style={{ marginBottom: '1rem', display: 'flex', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
          <span className="badge badge-blue">{article.category}</span>
          <span style={{ fontSize: '0.78rem', color: 'var(--color-text-muted)' }}>{article.readTime} min de lecture</span>
          <span style={{ fontSize: '0.78rem', color: 'var(--color-text-muted)' }}>
            {new Date(article.date).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </span>
        </div>

        <h1 style={{ marginBottom: '0.5rem' }}>{article.title}</h1>
        <p style={{ fontSize: '1.1rem', color: 'var(--color-text-muted)', marginBottom: '2rem', fontStyle: 'italic' }}>{article.subtitle}</p>

        {/* Cover photo */}
        {coverSrc && (
          <div style={{ borderRadius: 'var(--radius-xl)', overflow: 'hidden', marginBottom: '2.5rem' }}>
            <img src={coverSrc} alt={article.title} style={{ width: '100%', height: 380, objectFit: 'cover', display: 'block' }} />
          </div>
        )}

        {/* Content */}
        <div style={{ borderTop: coverSrc ? 'none' : '1px solid var(--color-border)', paddingTop: coverSrc ? 0 : '2rem' }}>
          {article.content.map((block, i) => renderBlock(block, i))}
        </div>

        {/* CTA */}
        <div style={{ borderTop: '1px solid var(--color-border)', marginTop: '3rem', paddingTop: '2rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <Link to="/accompagnement" className="btn btn-primary">Discuter de mon projet</Link>
          <Link to="/simulateurs" className="btn btn-outline">Simuler mon rendement</Link>
        </div>

        {/* Autres articles */}
        {others.length > 0 && (
          <div style={{ marginTop: '3rem' }}>
            <h3>Autres articles</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem' }}>
              {others.map(a => (
                <Link key={a.id} to={`/blog/${a.slug}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1.25rem', background: 'var(--color-bg-white)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-md)', textDecoration: 'none', color: 'inherit' }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: '0.95rem', color: 'var(--color-primary)' }}>{a.title}</div>
                    <div style={{ fontSize: '0.78rem', color: 'var(--color-text-muted)', marginTop: 2 }}>{a.category} · {a.readTime} min</div>
                  </div>
                  <span style={{ color: 'var(--color-accent)', fontSize: '0.82rem', fontWeight: 700 }}>Lire</span>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
